<template>
  <div>
    <h1>Geocercas</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar geocerca"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
      <b-table
        show-empty
        stacked="md"
        :items="getAllGeofences"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        emptyFilteredText="No existen registros por mostrar"
        empty-text="No existen registros por mostrar">
        <template v-slot:cell(acciones)="row">
          <router-link size="sm" :to="{name:'ViewGeofences', params: row.item}" class="mr-1"><b-button class="btn-sm" variant="outline-warning">Visualizar geocerca</b-button></router-link>
          <router-link size="sm" :to="{name:'UpdateGeofences', params: row.item}" class="mr-1"><b-button class="btn-sm" variant="outline-warning">Editar</b-button></router-link>
          <!-- <b-button style="margin-left: 5px" class="btn-sm" variant="outline-danger"  @click="showDeleteGeofenceModal(row.item)">Eliminar</b-button> -->
        </template>
      </b-table>
      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
        </b-col>
      </b-row>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getAllGeofences.loading">
      <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
  </div>
</template>
<script>
import { Modal } from 'ant-design-vue'
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const GET_GEOFENCES = gql`
query getAllGeofences{
  getAllGeofences{
    id
    name
    kmzFile
    updatedAt
    createdBy
    active
  }
}
`
const DELETE_GEOFENCE = gql`
mutation deleteGeofence($geofenceId: Int){
  deleteGeofence(geofenceId: $geofenceId){
    success
    message
  }
}
`
export default {
  data() {
    return {
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Nombre de la geocerca' },
        { key: 'createdBy', label: 'Creado por' },
        'Acciones',
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      getAllGeofences: [],
    }
  },
  apollo: {
    getAllGeofences: {
      query: GET_GEOFENCES,
      context: headers(),
      result({ data }) {
        this.totalRows = data.getAllGeofences.length
      },
      error(err) {
        console.log(err)
      },
    },
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    deleteGeofence(geofence) {
      this.$apollo.mutate({
        mutation: DELETE_GEOFENCE,
        context: headers(),
        variables: {
          geofenceId: parseInt(geofence.id),
        },
      })
        .then(data => {
          console.log(data)
          this.$apollo.queries.getAllGeofences.refetch()
        })
        .catch(error => {
          console.log(error)
        })
    },
    showDeleteGeofenceModal(geofence) {
      Modal.confirm({
        title: `¿Estás seguro(a) que deseas eliminar la geocerca ${geofence.name}?`,
        okText: 'Aceptar',
        cancelText: 'Cancelar',
        onOk: () => {
          this.deleteGeofence(geofence)
        },
      })
    },
  },
}
</script>
